module.exports = __webpack_public_path__ + "img/strebulaev.0eff1c8d.jpg";